import { Button } from 'components';
import { routerStore } from 'core';
import { staticURL } from 'core/url';
import React from 'react';
const PlansBreakdownUrl = 'https://wikifactory.com/pricing/#plans-breakdown';

type CreateTeamCardProps = {
  iconName?: string;
  subTitle?: React.ReactNode;
  description?: React.ReactNode;
};

export const CreateTeamCard = ({
  iconName = 'infoIconWithBackground',
  subTitle = 'Need to manage editors in an easier way?',
  description,
}: CreateTeamCardProps) => {
  const handleCreateTeam = () => {
    routerStore.navigate('home.newInitiative');
  };

  return (
    <>
      <img
        width={48}
        height={54}
        src={staticURL(`assets/icons/${iconName}.svg`)}
      />
      <div className='text-black mt-2'>{subTitle}</div>
      <div className='mt-2'>
        <Button
          text='Create a Team'
          icon='arrow_right'
          iconPosition='right'
          variant='tertiary'
          onClick={() => {
            handleCreateTeam();
          }}
        />
      </div>

      {description || (
        <div className='mt-2'>
          <a
            href={PlansBreakdownUrl}
            target='_blank'
            rel='noreferrer'
            className='underline'
          >
            Learn more about our Plans
          </a>
        </div>
      )}
    </>
  );
};
